import { render, staticRenderFns } from "./ProjectNote.vue?vue&type=template&id=d28d67d6&scoped=true"
import script from "./ProjectNote.vue?vue&type=script&lang=js"
export * from "./ProjectNote.vue?vue&type=script&lang=js"
import style0 from "./ProjectNote.vue?vue&type=style&index=0&id=d28d67d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28d67d6",
  null
  
)

export default component.exports